/*
 * Copyright (c) 2024 Ask Sage, Inc. All rights reserved.
 * This software is the confidential and proprietary information of Ask Sage, Inc.
 * You shall not disclose such confidential information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Ask Sage, Inc.
 * THIS SOFTWARE IS PROVIDED "AS IS" AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 * INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL ASK SAGE, INC.
 * OR ITS CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT
 * OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
 * STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * You may not use this software except in compliance with the License.
 * You may not modify, reverse engineer, or redistribute this software.
 */
import React, { useState, useEffect, useRef } from 'react';
import * as default_data from '../config.js'
import { getUser, getToken } from '../AuthService.js';
import { SelectPersona } from '../Chat/Components/SelectPersona.js'
import AddPrompt from './AddPrompt.js'
import { unEscapeHTML } from '../Utils/text_functions.js'
import { FiTrash2 } from 'react-icons/fi';
import { useMediaQuery, Box, Dialog, Stack, DialogTitle, Tab, Tabs, Button, TextField, IconButton, Card, CardContent, useTheme} from '@mui/material';
import { IoClose } from 'react-icons/io5';
import { NoResults } from '../Components/NoResults.js';
import { ScrollableDialogContent } from '../Components/ScrollableDialogContent.js';

const PromptList = ({ personas, handlePromptClick, triggerPromptList, setTriggerPromptList }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [prompts, setPrompts] = useState([]);
  const [filter_persona, setFilterPersona] = useState("all");
  const [user_id, setUserId] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [triggerAddPrompt, setTriggerAddPrompt] = useState(0);
  var loaded_static = false;

  const [modalIsOpen, setIsOpen] = React.useState(false);

  const theme = useTheme();

  function handlePersona(event) {
    setFilterPersona(event.target.value);
  }

  function addPrompt() {
    setTriggerAddPrompt(1)
  }

  function closeModal() {
    setTriggerPromptList(0);
    setIsOpen(false);
  }

  function handleSearchChange(event) {
    setSearchText(event.target.value);
  }

  function deleteClick(key) {
    if(key == null || key == '') {
      return;
    }

    var token = getToken()
    if(token === false) {
      return;
    }

    var user = getUser()

    if(user === false || user == null) {
       window.location = '/login';
    }
    setUserId(user.id)
  
    fetch(default_data.default_prompt_service_url + '/prompt', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'x-access-tokens': `${token}`
      },        
      body: JSON.stringify({
        id: key
      })
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('An error occurred while getting data.');
      })
      .then(data => {
        if(data.status != 200) {
            return;
        }
        loadPrompts()
      })
      .catch(error => {
        console.log(error);
      });    
  }

  function loadPrompts() {
    var token = getToken()
    if(token === false) {
      return;
    }

    var user = getUser()

    if(user === false || user == null) {
       window.location = '/login';
    }
    setUserId(user.id)
  
    fetch(default_data.default_prompt_service_url + '/get-prompts', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-access-tokens': `${token}`
      },        
      body: JSON.stringify({
      })
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('An error occurred while getting data.');
      })
      .then(data => {
        if(data.status != 200) {
            return;
        }
        data = data.response;
        setPrompts(data);
      })
      .catch(error => {
        console.log(error);
      });
  }

  useEffect(() => {
    if (triggerPromptList) {
      if (triggerPromptList === 1) {
        setIsOpen(true)
      }
    }
  }, [triggerPromptList]);

  useEffect(() => {

    if(loaded || loaded_static) {
      return;
    }

    setLoaded(true)
    loaded_static = true;

    loadPrompts()

    }, [])

    function getPersonaName(persona_label) {
      var name = 'Default';
      if(personas == null) {
        return name;
      }
      const parsedPersonaLabel = parseInt(persona_label);

      personas.forEach((element) => {
        const parsedLabel = parseInt(element['label']);        
        if (!isNaN(parsedLabel) && !isNaN(parsedPersonaLabel) && parsedLabel === parsedPersonaLabel) {
          name = element['name']
        }
      });    
      return name;
    }

    const filteredPrivateItems = prompts.filter((item) => {
      if (filter_persona != null && filter_persona !== "all") {
        return item.user_id === user_id && parseInt(item.persona) === filter_persona && (item.title.toLowerCase().includes(searchText.toLowerCase()) || item.description.toLowerCase().includes(searchText.toLowerCase()));
      } else {
        return item.user_id === user_id && (item.title.toLowerCase().includes(searchText.toLowerCase()) || item.description.toLowerCase().includes(searchText.toLowerCase()));
      }
    });
  
    const filteredPublicItems = prompts.filter((item) => {
      if (filter_persona != null && filter_persona !== "all") {
        return item.public === true && parseInt(item.persona) === filter_persona && (item.title.toLowerCase().includes(searchText.toLowerCase()) || item.description.toLowerCase().includes(searchText.toLowerCase()));
      } else {
        return item.public === true && (item.title.toLowerCase().includes(searchText.toLowerCase()) || item.description.toLowerCase().includes(searchText.toLowerCase()));
      }
    });

    const DisplayDataPrivate = () => {

      return (filteredPrivateItems.map(
      (info)=>{ 
          return(
            <PromptVignette key={info.id} info={info} promptClick={promptClick} />
          )
      }));      
    }

    const DisplayDataPublic = () => {
      return (filteredPublicItems.map(
      (info)=>{ 
          return(
            <PromptVignette key={info.id} info={info} promptClick={promptClick} />
          )
      }));      
    }      

    const PromptVignette = ( {info, promptClick }) => {
      return(
        <Card
          key={info.id}
          tag={info.id}
          className="prompt-item"
          onClick={promptClick}
          variant='outlined'
          sx={{
            width: '100%',
            backgroundColor: theme.palette.card.backgroundColor,
            marginBottom: '1rem',
            border: theme.palette.card.border,
            cursor: 'pointer',
            '&:hover': theme.palette.card.hover,
          }}
        >
          <CardContent tag={info.id} className="prompt-item-public" sx={{width:"100%"}}>
            {
              info.public === true ?
                <span>Public</span>
              :
              <span>Private</span>
            }
            <div tag={info.id} className="prompt-item-persona">
              {getPersonaName(info.persona)}
              {
                info.user_id == user_id ?
                <span 
                  className="sidecar-button-nobg" 
                  data-key={info.id} 
                  onClick={(e)=>{
                    e.stopPropagation();
                    deleteClick(info.id)
                  }}
                >
                  <FiTrash2 data-key={info.id} size={16} />
                </span>
                :
                ''
              }
            </div>
          </CardContent>
          <CardContent tag={info.id} className="prompt-item-title">
            {unEscapeHTML(info.title)}
          </CardContent>
          <CardContent tag={info.id} className="prompt-item-description">
            {unEscapeHTML(info.description)}
          </CardContent>
        </Card>      
      )
    }      

  function promptClick(e) {    
    var tag = e.target.getAttribute('tag');
    if(tag == null) {
      return;
    }
    tag = tag.toString();
    var prompt = null;
    var persona = 1;
    prompts.forEach((element) => {
      if(element['id'] == tag) {
        prompt = element['prompt']
        persona = element['persona']
      }
    });    

    if(prompt != null && prompt != "") {      
      handlePromptClick(unEscapeHTML(prompt), persona)
      closeModal()
    }
  }

  const fullScreen = useMediaQuery(theme.breakpoints.down('mobile'));
  
  return (
    <Dialog
      open={modalIsOpen}
      onClose={closeModal}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={true} 
      maxWidth="lg" 
      fullScreen={fullScreen}
    >
      <DialogTitle id="alert-dialog-title">
        <Box display={'flex'} justifyContent={'space-between'}>
          Prompt List
          <IconButton onClick={closeModal}>
            <IoClose />
          </IconButton>
        </Box>
      </DialogTitle>
      <ScrollableDialogContent sx={{ height: '80vh'}} modalIsOpen={modalIsOpen}>
        <AddPrompt loadPrompts={loadPrompts} setTriggerAddPrompt={setTriggerAddPrompt} triggerAddPrompt={triggerAddPrompt} personas={personas} />
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={1}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 2,
          }}
        >
          <Tabs value={activeTab} onChange={(e, newValue) => setActiveTab(newValue)}>
            <Tab label="Public" value={0} />
            <Tab label="Private" value={1} />
          </Tabs>
          <Button onClick={addPrompt} variant='contained'>Add Prompt Template</Button>
        </Stack>
        <div className="prompt-persona">
          <TextField
            type="text"
            placeholder="Search prompts"
            value={searchText}
            onChange={handleSearchChange}
            style={{ marginBottom: '1rem' }}
            size='small'
            fullWidth
          />

          <SelectPersona
            value={filter_persona}
            personas={personas}
            onChange={handlePersona}
            useAll="true"
            sxOverride={{ fontSize: '13px !important', width: '100%' }}
          />
        </div>

        <div className="prompt-container">              
          { 
            activeTab === 0 ? 
            (prompts.length === 0) ?
              <div className="loading">Loading...</div> : 
              (filteredPublicItems.length === 0) ?
                <NoResults message={'No Prompts Found'} />:
                <DisplayDataPublic />
            :
            (prompts.length === 0) ? 
              <div className="loading">Loading...</div> : 
              (filteredPrivateItems.length === 0) ?
                <NoResults message={'No Prompts Found'} />:
                <DisplayDataPrivate />
          }
          
        </div>
      </ScrollableDialogContent>
    </Dialog>
  );
}
export default PromptList;
